import React, { useState, useEffect } from 'react';
  // import Form from 'react-bootstrap/Form';
  import config from '../../../config/config.js';
  import axios from 'axios';
  import { Line } from 'react-chartjs-2';
  import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
//   import Nav from 'react-bootstrap/Nav';
//   import { Tabs } from "antd";
// import { color } from 'highcharts';
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
  

  const Overview = () => 
  {

    const [surveyCounts, setSurveyCounts] = useState({
      customer_count: 0,
      employee_count: 0,
      investor_count: 0,
      partner_count: 0,
    });
  
    useEffect(() => {
      const fetchSurveyCounts = async () => {
        try {
          const response = await axios.get(`${config.API_BASE_URL}/get_survey_counts.php`, {
            withCredentials: true, // Send cookies with the request if needed
          });
  
          if (response.data.success) {
            setSurveyCounts({
              customer_count: response.data.data.customer_count,
              employee_count: response.data.data.employee_count,
              investor_count: response.data.data.investor_count,
              partner_count: response.data.data.partner_count,
            });
          } else {
            console.error(response.data.message); // Log error message from the backend
          }
        } catch (error) {
          console.error('Error fetching survey counts:', error);
        }
      };
  
      fetchSurveyCounts();
    }, []);

    const [insightData, setInsightData] = useState([]);

    useEffect(() => {
      // Fetch data from your PHP backend
      fetch('https://api.skepper.in/get_overview_data.php', {
        method: 'GET',
        credentials: 'include', // Make sure cookies/session are sent with the request
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // Process and map the data to match the chart format
            const months = [
              'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
    
            const formattedData = months.map((month, index) => {
              const customer = data.data.customer_count[index + 1] || 0;
              const employee = data.data.employee_count[index + 1] || 0;
              const partner = data.data.partner_count[index + 1] || 0;
              const investor = data.data.investor_count[index + 1] || 0;
            
              return {
                month,
                customer,
                employee,
                partner,
                investor,
              };
            });
            
    
            setInsightData(formattedData);
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }, []);
    
    const colors = {
      customer: '#FF6384',
      employee: '#36A2EB',
      partner: '#FFCE56',
      investor: '#4BC0C0'
    };
    
    const chartData = {
      labels: insightData.map((label) => label.month),
      datasets: [
        {
          label: 'Customer',
          data: insightData.map((data) => data.customer),
          borderColor: colors.customer,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          fill: false,
          tension: 0.3,
          borderWidth: 1.5,
          pointBackgroundColor: 'white',
          pointBorderColor: '#000000',
          pointRadius: 0,
          pointHoverRadius: 3,
          hoverRadius: 3
        },
        {
          label: 'Employee',
          data: insightData.map((data) => data.employee),
          borderColor: colors.employee,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          fill: false,
          tension: 0.3,
          borderWidth: 1.5,
          pointBackgroundColor: 'white',
          pointBorderColor: '#000000',
          pointRadius: 0,
          pointHoverRadius: 3,
          hoverRadius: 3
        },
        {
          label: 'Partner',
          data: insightData.map((data) => data.partner),
          borderColor: colors.partner,
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: false,
          tension: 0.3,
          borderWidth: 1.5,
          pointBackgroundColor: 'white',
          pointBorderColor: '#4BC0C0',
          pointRadius: 0,
          pointHoverRadius: 3,
          hoverRadius: 3
        },
        {
          label: 'Investor',
          data: insightData.map((data) => data.investor),
          borderColor: colors.investor,
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: false,
          tension: 0.3,
          borderWidth: 1.5,
          pointBackgroundColor: 'white',
          pointBorderColor: '#4BC0C0',
          pointRadius: 0,
          pointHoverRadius: 3,
          hoverRadius: 3
        }
      ]
    };
    
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      hover: {
          mode: 'index',
          intersect: false
      },
      scales: {
          y: {
              type: 'linear',
              position: 'left',
              ticks: {
                  callback: function (value) {
                      return value;  // Display raw numbers (no percentage conversion)
                  },
                  stepSize: 10,  // Adjust this based on your data range for better readability
                  beginAtZero: true,  // Start Y-axis from zero for clarity
                  font: {
                      size: 10
                  },
                  padding: 10
              },
              grid: {
                  borderColor: '#dddddd',
                  borderWidth: 0.1,
                  drawTicks: false,
                  lineWidth: 0.4
              },
              border: {
                  color: '#dddddd',
                  width: 0
              }
          },
          x: {
              ticks: {
                  font: {
                      size: 10
                  },
                  padding: 15
              },
              grid: {
                  borderColor: '#dddddd',
                  borderWidth: 0.1,
                  drawTicks: false,
                  lineWidth: 0.4
              },
              border: {
                  color: '#dddddd',
                  width: 0
              }
          }
      },
      plugins: {
          legend: {
              display: false,
              position: 'top',
              labels: {
                  usePointStyle: false,
                  pointStyle: 'linear',
                  padding: 20,
                  color: '#000'
              }
          },
          tooltip: {
              mode: 'index',
              intersect: true,
              backgroundColor: '#FFFFFF',
              borderColor: '#E5E5E5',
              borderWidth: 1,
              titleFont: {
                  size: 12,
                  weight: 'bold'
              },
              titleColor: '#333',
              bodyFont: {
                  size: 12
              },
              bodyColor: '#333',
              displayColors: false,
              padding: 10,
              callbacks: {
                  label: function (context) {
                      let label = context.dataset.label || '';
                      let value = context.raw;
  
                      return `${label}: ${value}`;  // Show absolute values
                  },
                  labelTextColor: function (context) {
                      if (context.dataset.label === 'Partner') {
                          return '#FF8400';
                      } else {
                          return '#333';
                      }
                  },
                  title: function () {
                      return '';  // Removing title in tooltip for cleaner look
                  }
              }
          }
      }
  };
  
    
    const baseClass = 'container-fluid';
    const className = `${baseClass}`;

    return (
      
      <div className={className}  >

        <div className="d-sm-flex align-items-center justify-content-between mb-2 h_title">
          <h1 className="dashboard_heading">Overview</h1>
        </div>

        <div className="overview_box">
      <div className="box">
        <div className="view_box">
          <div className="total_num">
            <p className="box_heading">Customer</p>
            <h4 className="num_title">{surveyCounts.customer_count}</h4>
          </div>
          <div className="green_box"></div>
          <div className="box_icon">
            <img src="img/quantity.svg" alt="" />
          </div>
        </div>
      </div>

      <div className="box">
        <div className="view_box">
          <div className="total_num">
            <p className="box_heading">Employee</p>
            <h4 className="num_title">{surveyCounts.employee_count}</h4>
          </div>
          <div className="box_icon">
            <img src="img/quantity.svg" alt="" />
          </div>
        </div>
      </div>

      <div className="box">
        <div className="view_box">
          <div className="total_num">
            <p className="box_heading">Partner</p>
            <h4 className="num_title">{surveyCounts.partner_count}</h4>
          </div>
          <div className="box_icon">
            <img src="img/quantity.svg" alt="" />
          </div>
        </div>
      </div>

      <div className="box">
        <div className="view_box">
          <div className="total_num">
            <p className="box_heading">Investor</p>
            <h4 className="num_title">{surveyCounts.investor_count}</h4>
          </div>
          <div className="box_icon">
            <img src="img/quantity.svg" alt="" />
          </div>
        </div>
      </div>
    </div>

        <div className="right_wrapper top_space">
          <div className="split d-flex justify-content-around">

          <div className="graph_view border_line">
    <div className="graph_years d-flex justify-content-between align-items-baseline">
        <div className="title_graph">
            <p className="dashboard_title black_txt">Response Insights</p>
        </div>
        
     
    </div>

    
    <div className="chart-area " style={{ height: '300px', width:'100%' }}>
        <Line data={chartData} options={chartOptions} />
    </div>

    

    <div className="legend_lable">
        <div className="label_title">
            <div className="label_1">
                <span className="color_line"></span>
                <p>Customer</p>
            </div>
            <div className="label_2">
                <span className="color_line"></span>
                <p>Employee</p>
            </div>
            <div className="label_3">
                <span className="color_line"></span>
                <p>Partner</p>
            </div>
            <div className="label_4">
                <span className="color_line"></span>
                <p>Investor</p>
            </div>
        </div>
    </div>
</div>




         


          </div>
        </div>

       

      </div>
    );
  };

  export default Overview;
